import cx from 'classnames';
import type {RefObject} from 'react';
import {PhotoUploadButton} from '~/ViewInvitation/routes/Landing/PhotosModule/PhotoUploadButton';
import {Typography} from '~library/atoms/Typography';
import {PhotoGalleryIcon} from '~library/svg/PhotoGalleryIcon';

import './PhotosEmptyState.sass';

interface PhotosEmptyStateProps {
  showAddButton?: boolean;
  isCreationFlow?: boolean;
  emptyStateText?: string;
  handlePost?: () => void;
  fileUploadRef?: RefObject<HTMLInputElement> | null;
  isHostModule: boolean;
  fullWidth?: boolean;
}

export const PhotosEmptyState = ({
  showAddButton = false,
  emptyStateText = '',
  fileUploadRef = null,
  isHostModule,
  fullWidth = false,
}: PhotosEmptyStateProps) => {
  return (
    <div
      className={cx('photos-empty-state', {
        'photos-empty-state--preview': !showAddButton,
      })}
    >
      <PhotoGalleryIcon />
      <Typography variant="paragraph3" data-qa-id="host-photos-module-empty-state-description">
        {emptyStateText}
      </Typography>
      {showAddButton && (
        <PhotoUploadButton
          fullWidth={fullWidth}
          fileUploadRef={fileUploadRef}
          disabled={false}
          isHostModule={isHostModule}
        >
          Add photos
        </PhotoUploadButton>
      )}
    </div>
  );
};
